export default __webpack_public_path__ + "static/media/nameandrole3.f30c418b.png";